import { Field } from 'formik';
import { FsProps, CustomSelectComponent, FormCol6 } from 'motion-components';
import React from 'react';

export const FieldSelectGeometry = ({
  label = 'Γεωμετρία κυψελών;',
  name = 'xrbData.cellGeometry',
  as = FormCol6,
  ...rest
}: FsProps) => {
  //11;field;cellGeometry;enum('cylindrical','prismatic','pouch');;Γεωμετρία κυψελών;A1.7;
  const options = [
    { value: 'cylindrical', label: 'CYLINDRICAL' },
    { value: 'prismatic', label: 'PRISMATIC' },
    { value: 'pouch', label: 'POUCH' },
  ];
  return (
    <Field
      name={name}
      title={label}
      component={(props) => <CustomSelectComponent {...props} as={as} className="mb-0 p-0" />}
      options={options}
      useCreatableSelect={true}
      {...rest}
    />
  );
};
